export default __webpack_public_path__ + "static/methodology-eb056f85caec06bf9550005baa9d948a.svg";